// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getClaimSummary} from '../../shared/repositories';

export const readClaimSummary = params =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getClaimSummary(params);

            dispatch({
                data: {data: payload},
                type: actions.READ_CLAIM_SUMMARY_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/action-creators/claim-summary.js